import MemoryLocalStorage from './MemoryLocalStorage';
const COOKIE_CONSENT_KEY = 'cvt_cookie_consent';
export const COOKIE_CATEGORIES = ['Performance', 'Functionality', 'Marketing'];
export const getCookieConsentStorage = () => {
    let localStorageSupport = false;
    try {
        localStorageSupport = window.localStorage && true;
    }
    catch (e) {
        localStorageSupport = false;
    }
    if (localStorageSupport) {
        return window.localStorage;
    }
    return new MemoryLocalStorage();
};
export const cookieConsentStorage = getCookieConsentStorage();
const getKey = (siteIdentifier) => siteIdentifier ? `${COOKIE_CONSENT_KEY}-${siteIdentifier}` : COOKIE_CONSENT_KEY;
/**
 * Gets the current stored cookie consent data
 * @param siteIdentifier - additional identifier for the local storage key
 * @returns Cookie consent data
 */
export const getConsentData = (siteIdentifier) => {
    return cookieConsentStorage.getItem(getKey(siteIdentifier));
};
/**
 * Sets the stored cookie consent data
 * @param data
 * @param siteIdentifier - additional identifier for the local storage key
 */
export const setConsentData = (data, siteIdentifier) => {
    cookieConsentStorage.setItem(getKey(siteIdentifier), JSON.stringify(data));
};
/**
 * Clears the stored consent data
 */
export const clearConsentData = (siteIdentifier) => {
    cookieConsentStorage.removeItem(getKey(siteIdentifier));
};
//# sourceMappingURL=localStorageUtils.js.map